module.exports = __webpack_public_path__ + "img/male1.3862ea7b.jpg";